let Polling = (function ($) {
    window.dataLayer = window.dataLayer || [];

    const self = {
        timerVariables: {
            retryAttempt: 0,
            totalRetryAttempts: 0,
            pollIntervalInSeconds: 0,
            pollServiceUrl: '/api/sitecore/HealthReviewResult/PollHealthSpanDetails',
            heathSpanServiceUrl: '/api/Sitecore/HealthReviewResult/HealthSpan',
            recommendationServiceUrl: '/api/sitecore/Recommendation/RecommendationSection',
            pollVariable: '',
            pollTimerValue: 1000
        },
        elements: {
            totalRetryAttemptsId: '#totalRetryAttempts',
            pollIntervalInSecondsId: '#pollIntervalInSeconds',
            serviceUrlId: '#serviceUrl',
            loadingSection: '#loading-section',
            healthSpanSectionId: '#poll-success',
            healthSpanRecommendationSectionId: '#my-recommendation-carousel',
            resultHealthSpanSectionId: '#load-healthspan',
            resultHealthSpanRecommendationSectionId: '#load-signatureexperience',
            failureSectionId: '#poll-failure'
        },
        func: {
            init: function () {
                $(self.elements.healthSpanSectionId).hide();
                $(self.elements.failureSectionId).hide();
                self.func.poll();
            },
            poll: function () {
                self.func.getPollDetails();
                self.timerVariables.pollVariable = window.setInterval(self.func.getServiceResults,
                    self.timerVariables.pollIntervalInSeconds * self.timerVariables.pollTimerValue);
            },
            getPollDetails: function () {
                self.timerVariables.totalRetryAttempts = $(self.elements.totalRetryAttemptsId)[0].value;
                self.timerVariables.pollIntervalInSeconds = $(self.elements.pollIntervalInSecondsId)[0].value;
            },
            getServiceResults: function () {
                ++self.timerVariables.retryAttempt;

                if (self.timerVariables.retryAttempt <= self.timerVariables.totalRetryAttempts) {
                    $.ajax({
                        type: 'GET',
                        url: self.timerVariables.pollServiceUrl,
                        success: function (response) {
                            if (response) {
                                $(self.elements.failureSectionId).hide();
                                const url = $(location).attr('href');
                                const parts = url.split('/');
                                const lastPart = parts[parts.length - 1];

                                if (lastPart === 'healthy-living') {
                                    self.func.healthSpan();
                                    self.func.signatureExperience();
                                    self.func.recommendation();
                                } else {
                                    self.func.healthSpan();
                                    self.func.signatureExperience();
                                }

                                $(self.elements.loadingSection).hide();
                                $(self.elements.healthSpanSectionId).show();
                                window.clearInterval(self.timerVariables.pollVariable);
                            }
                        }
                    });
                } else {
                    $(self.elements.loadingSection).hide();
                    $(self.elements.failureSectionId).show();
                    window.clearInterval(self.timerVariables.pollVariable);
                }
            },
            healthSpan: function () {
                const dataSourceId = $('#healthspanDataSource')[0].value;
                $(self.elements.resultHealthSpanSectionId).load(self.timerVariables.heathSpanServiceUrl,
                    { dataSourceId: dataSourceId });
            },
            recommendation: function () {
                const dataSourceId = $('#recommendationDataSource')[0].value;
                $(self.elements.healthSpanRecommendationSectionId).load(self.timerVariables.recommendationServiceUrl,
                    { dataSourceId: dataSourceId });
            },
            signatureExperience: function () {
                const dataSourceId = $('#signatureExperienceDataSource')[0].value;
                $(self.elements.resultHealthSpanRecommendationSectionId).load(self.timerVariables.heathSpanServiceUrl,
                    { dataSourceId: dataSourceId });
            }
        }
    };

    return {
        init: self.func.init
    };
})(jQuery);

$('document').ready(function () {
    if ('wide-card-with-poll' === window.$('#loading-section').data('feature')) {
        Polling.init();
    }
});
